import React, { useEffect, useState } from "react";
import "./Skeleton.css";
export default function Skeleton({ type }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    // Update screenWidth when the window is resized
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const counter = screenWidth > 768 ? 3 : 1;
  const counterNews = screenWidth > 768 ? 8 : 1;
  const counterUpcomingAndRecent = screenWidth > 768 ? 4 : 1;
  const liveScoreSkeleton = screenWidth > 768 ? 1 : 1;
  const FixturesSkeleton = () => (
    <div className={type === 'fixtures' ? "fixtureSkeletonWrapper" : "UpcomingAndRecentSkeletonWrapper" }>
      <div className="matchDataSk">
        <div className="firstContainerSk"></div>
        <div className="secondContainerSk"></div>
        <div className="thirdContainerSk">
          <div className="teamDetails">
            <div className="teamLogo"></div>
            <div className="teamShortName"></div>
            <div className="teamScore"></div>
          </div>
          <div className="teamDetails">
            <div className="teamLogo"></div>
            <div className="teamShortName"></div>
            <div className="teamScore"></div>
          </div>
        </div>
        <div className="fourthContainerSk">
          <div className="firstRatesk"></div>
          <div className="secondRatesk"></div>
        </div>
      </div>
      <div className="pointsTableSk"></div>
    </div>
  );

  const SeriesSkeletonFeed = () => (
    <div className="seriesDataSk">
      <div className="seriesFirstContainerSk">
        <div className="seriesNameSk"></div>
        <div className="seriesDatesSk"></div>
        <div className="totalMatchesSk"></div>
      </div>
      <div className="seriesSecondContainerSk"></div>
    </div>
  );

  const NewsSkeleton = () => (
    <div className="newsDataSk">
      <div className="newsFirstContainerSk"></div>
      <div className="newsSecondContainerSk"></div>
      <div className="newsThirdContainerSk"></div>
    </div>
  );

  const ScoreCardSkeleton = () => (
    <div className="scoreCardSk">
      <div className="scoreCardFirstContainerSk"></div>
      <div className="scoreCardSecondContainerSk"></div>
      
    </div>
  );

  if (type === "fixtures") return Array(counter).fill(<FixturesSkeleton />);
  if (type === "UpcomingAndRecent") return Array(counterUpcomingAndRecent).fill(<FixturesSkeleton />);
  if (type === "liveScoreSkeleton") return Array(liveScoreSkeleton).fill(<FixturesSkeleton />);
  if (type === "series") return Array(counter).fill(<SeriesSkeletonFeed />);
  if (type === "news") return Array(counterNews).fill(<NewsSkeleton />);
  if (type === "scoreCardSkeleton") return Array(liveScoreSkeleton).fill(<ScoreCardSkeleton />);
}
